<template>
  <div class="whitespace-nowrap">
    <div class="buttons">
      <button class="button" v-for="date in dates" :key="date" :class="{ 'active': date === $route.query?.date }" @click="useUpdateQuery({ date: date })">
        <div class="font-bold text-lg md:text-xl">
          <div class="max-md:hidden" v-auto-animate>
            <div class="_font-normal" v-if="date === $route.query?.date">{{ useUcFirst($dayjs(date).format('dddd')) }}</div>
            <div v-else>{{ useUcFirst($dayjs(date).format('ddd')) }}</div>
          </div>
          <div class="md:hidden">
            {{ useUcFirst($dayjs(date).format('ddd')) }}
          </div>
        </div>
        <div class="text-sm text-black">{{ useUcFirst($dayjs(date).format('D MMMM')) }}</div>
      </button>
    </div>
  </div>
</template>

<script setup>
const dates = [
  '2025-06-02',
  '2025-06-03',
  '2025-06-04',
  '2025-06-05',
]
</script>

<style lang="scss" scoped>
.buttons {
  @apply flex items-center gap-5 md:gap-6;

  button {
    @apply duration-300 text-left;

    &.active {
      @apply border-coral text-coral;

      &:deep(svg) {
        @apply text-black;
      }
    }
  }
}
</style>